import React, { useState } from "react";
import { Tabs, Empty } from "antd";
import AllManifestList from "./allManifestList";
import CpWiseManifest from "./cpWiseManifestList";
import ThreePLWiseManifest from "./threePLWiseManifestList";
import Heading from "../../../components/Heading";
import sorting from "../../../assests/images/SVG/sort-white.svg";
import { useSearchParams, useNavigate } from "react-router-dom";

const items = [
  {
    key: "1",
    label: "All Manifests",
    children: <AllManifestList />,
  },
  {
    key: "2",
    label: "CP Wise Manifest",
    // children will be set dynamically
  },
  {
    key: "3",
    label: "3PL Wise Manifest",
    // children will be set dynamically
  },
  {
    key: "4",
    label: "Hub Delivery",
    children: <Empty />,
  },
];

const Index = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tabFromUrl = searchParams.get("tab") || "1";
  const [activeTab, setActiveTab] = useState(tabFromUrl);
  const [cpWiseKey, setCpWiseKey] = useState(Date.now());
  const [threePlKey, setThreePlKey] = useState(Date.now());

  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);
    // Always update URL so it doesn't get stuck on old values (e.g. ?tab=2) when switching back, preventing jumping when Layout remounts
    navigate(window.location.pathname + "?tab=" + activeKey, { replace: true, state: undefined });
    
    if (activeKey === "2") {
      setCpWiseKey(Date.now());
    }
    if (activeKey === "3") {
      setThreePlKey(Date.now());
    }
  };

  // Set CpWiseManifest with key for tab 2 and ThreePL for tab 3
  const tabItems = items.map(item =>
    item.key === "2"
      ? { ...item, children: <CpWiseManifest key={cpWiseKey} /> }
      : item.key === "3"
        ? { ...item, children: <ThreePLWiseManifest key={threePlKey} /> }
        : item
  );

  return (
    <div className="p-1 master-main-container">
      <Heading title={"Manifest List"} navigateTo={"/hub-in-scan"} imgSrc={sorting} />
      <Tabs
        defaultActiveKey={tabFromUrl}
        activeKey={activeTab}
        items={tabItems}
        onChange={handleTabChange}
      />
    </div>
  );
};

export default Index;
